// TODO: maybe move to another folder?
import { useEffect, useCallback, useRef } from 'react';
// React hook for delaying calls with time
// returns callback to use for cancelling
export const useInterval = (callback, // function to call. No args passed.
// if you create a new callback each render, then previous callback will be cancelled on render.
timeout = 0 // delay, ms (default: immediately put into JS Event Queue)
) => {
    const timeoutIdRef = useRef();
    const cancel = useCallback(() => {
        const timeoutId = timeoutIdRef.current;
        if (timeoutId) {
            timeoutIdRef.current = undefined;
            clearInterval(timeoutId);
        }
    }, [timeoutIdRef]);
    useEffect(() => {
        timeoutIdRef.current = setInterval(callback, timeout); // todo
        return cancel;
    }, [callback, timeout, cancel]);
    return cancel;
};
